import { Avatar, Icon, Tag, Text } from "components/common";
import { useNavigate } from "react-router-dom";
import FollowButton from "../followButton";
import theme from "utils/themeVars";
import { getUserProfilePath } from "constants/app-paths";
import styles from "./index.module.less";

export const UserAvatar = ({ user, size = 44 }) => {
  const initial =
    (user?.name || user?.firstname || user?.username || "U")
      ?.trim()
      ?.charAt(0)
      ?.toUpperCase() || "U";
  return (
    <Avatar
      size={size}
      src={user?.profile_url || undefined}
      colorKey={initial.toLowerCase()}
    >
      {!user?.profile_url && initial}
    </Avatar>
  );
};

export const badgeColor = (badge) => {
  if (badge === "Educator") return theme["accent-color"];
  if (badge === "Learner") return theme["gray800"];
  return theme["primary-color"];
};

const formatNumber = (value) => Number(value || 0).toLocaleString();

const UserListRow = ({
  user,
  showFollow = true,
  onChanged = () => {},
  listType,
}) => {
  const navigate = useNavigate();
  if (!user) return null;

  const goToProfile = () => navigate(getUserProfilePath(user.user_code));
  const role = user.badge || (user.user_role === "EDITOR" ? "Educator" : "Learner");
  const stats = user.stats || {};
  const isFollowBack = listType === "followers" && user.relationship === "none";

  return (
    <div className={styles.row}>
      <div className={styles.avatar} onClick={goToProfile}>
        <UserAvatar user={user} size={60} />
      </div>
      <div className={styles.identity} onClick={goToProfile}>
        <div className={styles.nameRow}>
          <Text style={{ fontWeight: 600 }}>{user.name || "User"}</Text>
          {role && (
            <Tag
              color={badgeColor(role)}
              type="light"
              pill
              style={{ marginInlineEnd: 0 }}
            >
              {role}
            </Tag>
          )}
          {user.educationLevel && <span className={styles.educationLevel}>{user.educationLevel}</span>}
        </div>
        {user.username && (
          <Text className="gray-800" style={{ fontSize: 13 }}>
            @{user.username}
          </Text>
        )}
        {user.bio && <Text className={styles.bio}>{user.bio}</Text>}
        <div className={styles.metaRow}>
          {user.specialties?.slice(0, 2).map((specialty) => <span key={specialty} className={styles.specialty}>{specialty}</span>)}
          {stats.questionsAnswered !== null && stats.questionsAnswered !== undefined && <span><Icon icon="MdOutlineQuiz" size={12} /> {formatNumber(stats.questionsAnswered)}</span>}
          {stats.accuracy !== null && stats.accuracy !== undefined && <span><Icon icon="AiOutlineStar" size={12} /> {stats.accuracy}%</span>}
        </div>
        <div className={styles.connectionMeta}>
          <span><Icon icon="FiUsers" size={12} /> {formatNumber(user.followersCount)} followers</span>
          <span>Following {formatNumber(user.followingCount)}</span>
          {Number(user.mutualFollowers || 0) > 0 && <span>{formatNumber(user.mutualFollowers)} mutual</span>}
        </div>
      </div>
      {showFollow && (
        <div className={styles.followAction}>
          <FollowButton
            size="small"
            variant="subtle"
            userCode={user.user_code}
            relationship={user.relationship}
            onChanged={onChanged}
            followText={isFollowBack ? "Follow back" : "Follow"}
          />
        </div>
      )}
    </div>
  );
};

export default UserListRow;
